import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useMember } from 'lib/hooks/queries/member/useMember';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import StaffMember from './components/StaffMember';
import { defaultColumns, defaultFilters } from './lib/helpers';

const StaffModal = ({ isOpen, item: selectedStaff, handleClose }) => {
  const { id } = useParams();

  if (!isOpen) return null;

  return (
    <StaffMember practiceId={id} member={selectedStaff} handleOpen={isOpen} onClose={handleClose} />
  );
};

const Staff = () => {
  const columnDefs = useMemo(() => defaultColumns(), []);

  return (
    <AgTablePage
      defaultColumns={columnDefs}
      defaultFilters={defaultFilters}
      useData={useMember}
      title="Staff"
      name="members"
      rowStyle={{ cursor: 'pointer' }}
      ModalComponent={StaffModal}
      noNewButton
    />
  );
};

export default Staff;
